angular
    .module('userNotifications.v1')
    .directive('needsPrintFilesCount', needsPrintFilesCount);

/**
 * @ngdoc directive
 * @name userNotifications.v1.directive:needsPrintFilesCount
 * @restrict A
 * @element any
 *
 * @description
 * Displays the count of all jobs marked as "needs print files"
 *
 * #### Script file
 * - `/web3/build/storefront/widgets/needs-print-files-count.v1.directive.js`
 *
 * #### Classes
 * - `isPending` : applied while notifications are in the proces of loading
 * - `isEmpty` : applied when the total notification count is 0
 *
 * #### Events
 * - `window.events.NEEDS_PRINT_FILES_LIST_UPDATED` : raised whenever the notification count changes
 *
 * @example
    <pre>
        <!-- load widget script -->
        <script src="/web3/build/storefront/widgets/needs-print-files-count.v1.directive.js"></script>

        <!-- display widget count -->
        <span needs-print-files-count></span>

        <!-- respond to events -->
        <script>
            window.events.listen(window.events.NEEDS_PRINT_FILES_LIST_UPDATED, function () {
                console.log('needs print files count updated');
            });
        </script>
    </pre>
    */

needsPrintFilesCount.$inject = [];

function needsPrintFilesCount () {
    return {
        restrict: 'A',
        template: '<span ng-bind="needsPrintFilesCountController.count"></span>',
        link: function totalNotificationCount_linkFn (scope, element, attrs, controller, transclude) {},
        controller: NeedsPrintFilesCountController,
        controllerAs: 'needsPrintFilesCountController',
        bindToController: true,
        scope: {}
    };
};

NeedsPrintFilesCountController.$inject = ['$scope', '$element', 'userNotificationsService', 'authService', '$timeout'];

function NeedsPrintFilesCountController ($scope, $element, userNotificationsService, authService, $timeout) {
    var vm = this;

    vm.count = 0;

    init();

    return;

    function init () {
        $element
            .addClass('isEmpty')
            .addClass('isPending');
        // Subscribe to auth changes
        authService.subscribe($scope, handleAuthChange);
        // Subscribe to needsPrintFilesItems updates
        userNotificationsService.needsPrintFilesItems.subscribe($scope, handleNeedsPrintFilesItemsUpdate);
        // Subscribe to classic events
        userNotificationsService.classicEvents.subscribe($scope, getNeedsPrintFilesCount);
        // Initial loading of needsPrintFilesItems
        getNeedsPrintFilesCount();
    }

    function handleAuthChange ($event, user) {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        getNeedsPrintFilesCount();
    }

    function getNeedsPrintFilesCount () {
        if (!authService.isLoggedIn()) {
            return resetDirective();
        }

        userNotificationsService.needsPrintFilesItems.get(authService.getUser().id);
    }

    function handleNeedsPrintFilesItemsUpdate ($event, needsPrintFilesItems) {
        if (!needsPrintFilesItems) {
            return resetDirective();
        }

        if (!needsPrintFilesItems.length) {
            $element.addClass('isEmpty');
        } else {
            $element.removeClass('isEmpty');
        }

        $timeout(function(){
            vm.count = needsPrintFilesItems.length;
        });
        $element
            .show()
            .removeClass('isPending');
    }

    function resetDirective () {
        vm.count = 0;
        $element
            .hide()
            .addClass('isEmpty')
            .removeClass('isPending');
    }
};